import React, { FC, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RESET_ALL } from '../../reducers/RootReducer';
import classes from './TimeOver.module.css';
import Button from "../Button";

const REDIRECT_DELAY = 3;

interface TimeOverProps {
  onGoHome?: () => void;
}

const TimeOver: FC<TimeOverProps> = ({ onGoHome }) => {
  const dispatch = useDispatch();
  const [countdown, setCountdown] = useState(REDIRECT_DELAY);

  const handleReset = () => {
    dispatch({ type: RESET_ALL });
    onGoHome?.();
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          handleReset();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={classes.root}>
      {/*<div className={classes.timerCircle}>
        <span className={classes.time}>0:00</span>
      </div>*/}

      <span className={classes.time}>Time Out</span>
    {/*  <p className={classes.message}>
        The 60 seconds ran out before your ring was submitted.<br/>
        so this one is out of the challenge
      </p>*/}

      <p className={classes.redirectMsg}>Returning to home in {countdown}…</p>

      <Button type="button" buttonType="btnPrimary" className={classes.btn} onClick={handleReset}>
        Start over
      </Button>
    </div>
  );
};

export default TimeOver;
